export const footerText = {
  en: {
    collaborationNote: "Open for any collaboration",
    consultationTitle:
      "Hire our development team now to work on your project!",
    introParagraph:
      "Ready to hire a complete development team? Contact us to discuss how FNDRS can provide you with developers, designers, engineers, and experts ready to work on your project.",
    cta: "Get started today",
    contactEmail: "Email address",
    contactLabel: "contact@fndrs.com",
    socialTitle: "Visit us on:",
    navTitle: "Navigation",
    navLinks: [
      { label: "Homepage", href: "#home" },
      { label: "Services", href: "/#services" },
      { label: "Our Process", href: "/#process" },
    ],
    companyTitle: "Company",
    companyLinks: [
      { label: "About us", href: "/#about" },
      { label: "Career", href: "/#team" },
    ],
    legalTitle: "Legal",
    legalLinks: [
      { label: "Terms of service", href: "/terms" },
      { label: "Privacy policy", href: "/privacy" },
    ],
    copyright: (year: number) =>
      `Copyright © ${year} FNDRS. All Rights Reserved.`,
  },

  es: {
    collaborationNote: "Abiertos a cualquier colaboración",
    consultationTitle:
      "¡Contrata nuestro equipo de desarrollo ahora para trabajar en tu proyecto!",
    introParagraph:
      "¿Listo para contratar un equipo completo de desarrollo? Contáctanos para conversar sobre cómo FNDRS puede proporcionarte desarrolladores, diseñadores, ingenieros y expertos listos para trabajar en tu proyecto.",
    cta: "Empezar ahora",
    contactEmail: "Correo electrónico",
    contactLabel: "contacto@fndrs.com",
    socialTitle: "Visítanos en:",
    navTitle: "Navegación",
    navLinks: [
      { label: "Inicio", href: "/#home" },
      { label: "Servicios", href: "/#services" },
      { label: "Nuestro proceso", href: "/#process" },
    ],
    companyTitle: "Compañía",
    companyLinks: [
      { label: "Sobre nosotros", href: "/#about" },
      { label: "Carrera", href: "/#team" },
    ],
    legalTitle: "Legal",
    legalLinks: [
      { label: "Términos del servicio", href: "/terms" },
      { label: "Política de privacidad", href: "/privacy" },
    ],
    copyright: (year: number) =>
      `Copyright © ${year} FNDRS. Todos los derechos reservados.`,
  },

  ja: {
    collaborationNote: "どんなコラボレーションでも歓迎します",
    consultationTitle:
      "今すぐ私たちの開発チームを雇って、あなたのプロジェクトで働きましょう！",
    introParagraph:
      "完全な開発チームを雇う準備はできていますか？お気軽にご連絡ください。FNDRSがあなたに開発者、デザイナー、エンジニア、専門家のチームを提供し、プロジェクトで働く準備ができています。",
    cta: "今すぐ始める",
    contactEmail: "メールアドレス",
    contactLabel: "contact@fndrs.com",
    socialTitle: "フォローはこちら：",
    navTitle: "ナビゲーション",
    navLinks: [
      { label: "ホーム", href: "/#home" },
      { label: "サービス", href: "/#services" },
      { label: "私たちのプロセス", href: "/#process" },
    ],
    companyTitle: "会社情報",
    companyLinks: [
      { label: "私たちについて", href: "/#about" },
      { label: "キャリア", href: "/#team" },
    ],
    legalTitle: "法務",
    legalLinks: [
      { label: "利用規約", href: "/terms" },
      { label: "プライバシーポリシー", href: "/privacy" },
    ],
    copyright: (year: number) =>
      `Copyright © ${year} FNDRS. 無断転載を禁じます。`,
  },
};
